import { useTranslation } from 'react-i18next';

export const GroupingHeader: React.FC = () => {
  const { t } = useTranslation();

  return <strong className="ml5 mr5">{t('TABLE_BUILDER.ENABLE_GROUPING_BAR')}</strong>;
};
